import { all } from "redux-saga/effects";
import { watchMount, watchPatchScormPackage, watchUnmount } from "./watchers";

export function* scormPackageManagementSagas() {
  yield all([watchMount(), watchPatchScormPackage(), watchUnmount()]);
}
